import startCase from 'lodash/startCase';
import { MEDIA_QUERY } from '../constants/styles';
import pathToTitleDescriptor from './converters/pathToTitle';

export const isDesktop = () => !window.matchMedia(MEDIA_QUERY).matches;

export const getMobileTitle = (userName, path, formatMessage) => {
  const messageDescriptor = path && pathToTitleDescriptor(path);
  const str = startCase(formatMessage(messageDescriptor));

  if (userName && messageDescriptor) {
    return `${userName}: ${str}`;
  }

  return str || userName;
};



// WEBPACK FOOTER //
// ./src/utils/mobileHelpers.js